import { FC } from 'react';

import { Heading } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

import { HiddenScrollbarGridContainer } from '@/components/atoms/HiddenScrollbarContainer';
import { CaseStudyCardMd } from '@/components/molecules/CaseStudyCards';
import { SectionContentWrapper, SectionWrapper } from '@/components/wrappers';
import { CaseStudyFragment } from '@/graphql/generated';
import { LOCALES } from '@/utils/constants';
import { CaseStudiesPath, getDynamicPath } from '@/utils/models';

type CaseStudyRecommendedProps = {
  caseStudies: CaseStudyFragment[] | undefined;
};

export const CaseStudyRecommended: FC<CaseStudyRecommendedProps> = ({ caseStudies }) => {
  const { t } = useTranslation(LOCALES.CASE_STUDY);

  if (!caseStudies || !Array.isArray(caseStudies)) {
    return null;
  }

  return (
    <SectionWrapper>
      <SectionContentWrapper>
        <Heading
          variant={{
            base: 'component-heading-large/lg',
            sm: 'component-heading-large/2xl',
          }}
          mb="10"
        >
          {t('recommends.other')}
        </Heading>

        <HiddenScrollbarGridContainer
          templateColumns={{
            base: 'repeat(3, minmax(280px, 1fr))',
            sm: 'repeat(3,minmax(338px, 1fr))',
            lg: 'repeat(3,minmax(405px, 1fr))',
          }}
          gap={{
            base: '3',
            sm: '6',
          }}
          overflowX="auto"
          overflowY="hidden"
        >
          {caseStudies.map((item) => {
            return (
              item.attributes && (
                <CaseStudyCardMd
                  key={item.id}
                  href={getDynamicPath(CaseStudiesPath.CASE_STUDY, item.attributes.slug)}
                  coverImage={item.attributes.image}
                  title={item.attributes.title}
                  description={item.attributes.description}
                />
              )
            );
          })}
        </HiddenScrollbarGridContainer>
      </SectionContentWrapper>
    </SectionWrapper>
  );
};
